import React from 'react';
import { useTranslation } from 'react-i18next';
import MainLayout from '@/components/layout/MainLayout';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface LegalSection {
  heading: string;
  paragraphs?: string[];
}

const MentionsLegalesPage = () => {
  const { t, i18n } = useTranslation('legal');
  const sections = t('mentions.sections', { returnObjects: true }) as LegalSection[];

  return (
    <MainLayout>
      <div className="container mx-auto py-8 px-4">
        <h1 className="text-3xl font-bold text-center mb-8">{t('mentions.pageTitle')}</h1>

        <Card className="max-w-4xl mx-auto">
          <CardHeader>
            <CardTitle>{t('mentions.cardTitle')}</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            {sections.map((section, index) => (
              <section key={index}>
                <h2 className="text-xl font-semibold mb-3">{section.heading}</h2>
                {section.paragraphs?.map((paragraph, pIndex) => (
                  <p
                    key={pIndex}
                    className={`text-muted-foreground ${pIndex > 0 ? 'mt-2' : ''}`}
                    dangerouslySetInnerHTML={{ __html: paragraph }}
                  />
                ))}
              </section>
            ))}

            {!i18n.language.startsWith('fr') && (
              <p className="text-xs text-muted-foreground mt-6">{t('prevailNotice')}</p>
            )}
          </CardContent>
        </Card>
      </div>
    </MainLayout>
  );
};

export default MentionsLegalesPage;
